import { Course } from './../builders/course_builder';
import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';

angular
  .module('capability-ng-transfer')
  .factory(
    'checkTransferStudentCourseIsReviewedCommand',
    (defineCommand: IDefineCommand, $http: ng.IHttpService, updateReviewCourseStatusCommand: ICommand): ICommand => {
      return defineCommand(
        'checkTransferStudentCourseIsReviewedCommand',
        (deferred: ng.IDeferred<IQuery[]>, course: Course) => {
          const url = `student/college/${course.college_nk}/course/${course.id}/review-status/`;
          $http({
            method: 'GET',
            url: url
          })
            .then((response: ng.IHttpPromiseCallbackArg<any>) => {
              updateReviewCourseStatusCommand(course, response.data.results.reviewed).then(() => deferred.resolve());
            })
            .catch(deferred.reject);
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/check_transfer_student_course_is_reviewed_command.ts